import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.a`
  color: ${props => props.theme.secondaryColor};
  text-align: center;
  background-color: ${props => props.theme.secondaryColorLight};
  margin: 0px 10px 10px 0px;
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 24px;
  border-radius: 2px;
  min-width: 4.6em;
  display: inline-block;
  padding: 0 10px;

  &&:hover {
    color: ${props => props.theme.secondaryColor};
    text-decoration: none;
  }
`;

export default function Expertise({ expertise }) {
  return (
    <Container href={`/profiles/experts_in/${expertise.slug}`}>
      {expertise.name}
    </Container>
  );
}

Expertise.propTypes = {
  expertise: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
